// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthClosure\ApiBerthClosure.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { Issue, IssueData, IssueOptions } from 'data/models/Issue';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';

// BerthClosureData is the class that BerthClosure serializes to/from
export interface BerthClosureData {
    Id : number;
    Url : string | null;
	
    Berth : BerthData | null;
    BerthId : number;
    Issues : IssueData[] | null;
    OthersIssues : IssueData[] | null;
    ReservationIssues : IssueData[] | null;
	
    EndDate : /* ISO8601 */ string | null;
    Footmark : MeasurementData;
    Length : MeasurementData;
    Remarks : string | null;
    StartDate : /* ISO8601 */ string;
    Title : string;
}

// BerthClosureOptions is the class which may be passed to the BerthClosure constructor to define optional initial data values
export interface BerthClosureOptions {
    Id : number;
    Url? : string | null;
	
    Berth? : BerthOptions | null;
    BerthId? : number;
    Issues? : IssueOptions[] | null;
    OthersIssues? : IssueOptions[] | null;
    ReservationIssues? : IssueOptions[] | null;
	
    EndDate? : /* ISO8601 */ string | null;
    Footmark? : MeasurementOptions;
    Length? : MeasurementOptions;
    Remarks? : string | null;
    StartDate? : /* ISO8601 */ string;
    Title? : string;
}

export class BerthClosure {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Berth : DataSignal<Berth | null>;
    public BerthId : DataSignal<number>;
    public Issues : SDataArray<Issue>;
    public OthersIssues : SDataArray<Issue>;
    public ReservationIssues : SDataArray<Issue>;
	
    public EndDate : DataSignal<TZDate | null>;
    public Footmark : Measurement;
    public Length : Measurement;
    public Remarks : DataSignal<string | null>;
    public StartDate : DataSignal<TZDate>;
    public Title : DataSignal<string>;

    constructor();
    constructor(data : BerthClosureOptions);
    constructor(data: BerthClosureOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Berth = S.value<Berth | null>(null);
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Issues = SArray<Issue>([]);
        this.OthersIssues = SArray<Issue>([]);
        this.ReservationIssues = SArray<Issue>([]);
	    
        this.EndDate = jsonableObservable(S.value<TZDate | null>(data && data.EndDate !== undefined ? data.EndDate === null ? null : new TZDate(data.EndDate) : null, TZDate.nullableEq));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement(data.Footmark) : new Measurement();
        this.Length = data && data.Length !== undefined ? new Measurement(data.Length) : new Measurement();
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
        this.StartDate = jsonableObservable(S.value<TZDate>(data && data.StartDate !== undefined ? new TZDate(data.StartDate) : new TZDate(0), TZDate.eq));
        this.Title = jsonableObservable(S.value<string>(data && data.Title !== undefined ? data.Title : ''));
    }

    static key(obj : BerthClosure) {
        return obj.Id();
    }
    
    static dataKey(obj : BerthClosureOptions) {
        return obj.Id;
    }

    static update(obj : BerthClosure, data : BerthClosureOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
	        
            if (data.EndDate !== undefined) obj.EndDate(data.EndDate === null ? null : new TZDate(data.EndDate));
            if (data.Footmark !== undefined) Measurement.update(obj.Footmark, data.Footmark);
            if (data.Length !== undefined) Measurement.update(obj.Length, data.Length);
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
            if (data.StartDate !== undefined) obj.StartDate(new TZDate(data.StartDate));
            if (data.Title !== undefined) obj.Title(data.Title);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthClosure.ts